import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M5.208 11.875s-1.25-.208-1.25-1.875a2.709 2.709 0 0 1 2.506-2.7 3.542 3.542 0 0 1 7.072 0 2.709 2.709 0 0 1 2.506 2.7c0 1.667-1.25 1.875-1.25 1.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M11.875 12.708 10 10.625l-1.875 2.083M10 16.042v-4.584" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);